module.exports = __webpack_public_path__ + "static/media/hanukkah.027539bc.jpg";